import MINECRAFT_ITEMS from './minecraftItems';

/**
 * Items that are NOT placeable blocks — filtered out to produce a blocks-only list.
 * Patterns checked via endsWith/startsWith/exact match for performance.
 */
const ITEM_SUFFIXES = [
  '_spawn_egg', '_boat', '_chest_boat', '_raft', '_chest_raft',
  '_pickaxe', '_axe', '_shovel', '_hoe', '_sword',
  '_helmet', '_chestplate', '_leggings', '_boots',
  '_horse_armor', '_dye', '_minecart',
  '_on_a_stick',
];

const ITEM_PREFIXES = [
  'music_disc_', 'potion', 'splash_potion', 'lingering_potion',
  'tipped_arrow',
];

const ITEM_EXACT = new Set([
  // Food & consumables
  'apple', 'baked_potato', 'beef', 'bread', 'chicken', 'cod', 'cookie',
  'cooked_beef', 'cooked_chicken', 'cooked_cod', 'cooked_mutton',
  'cooked_porkchop', 'cooked_rabbit', 'cooked_salmon', 'dried_kelp',
  'enchanted_golden_apple', 'golden_apple', 'golden_carrot', 'melon_slice',
  'mushroom_stew', 'mutton', 'porkchop', 'pufferfish', 'rabbit',
  'rabbit_stew', 'rotten_flesh', 'salmon', 'suspicious_stew',
  'sweet_berries', 'glow_berries', 'beetroot_soup', 'tropical_fish',
  'beetroot', 'honey_bottle', 'poisonous_potato', 'chorus_fruit',
  'popped_chorus_fruit', 'glistering_melon_slice', 'ominous_bottle',

  // Raw materials & crafting ingredients
  'amethyst_shard', 'blaze_powder', 'blaze_rod', 'bone', 'bone_meal',
  'bowl', 'brick', 'charcoal', 'clay_ball', 'coal', 'cocoa_beans',
  'copper_ingot', 'diamond', 'echo_shard', 'egg', 'emerald',
  'ender_pearl', 'ender_eye', 'experience_bottle', 'feather',
  'fermented_spider_eye', 'flint', 'ghast_tear', 'glass_bottle',
  'glow_ink_sac', 'glowstone_dust', 'gold_ingot', 'gold_nugget',
  'gunpowder', 'heart_of_the_sea', 'honeycomb', 'ink_sac',
  'iron_ingot', 'iron_nugget', 'lapis_lazuli', 'leather',
  'magma_cream', 'nautilus_shell', 'nether_brick', 'nether_star',
  'netherite_ingot', 'netherite_scrap', 'paper', 'phantom_membrane',
  'prismarine_crystals', 'prismarine_shard', 'quartz', 'rabbit_foot',
  'rabbit_hide', 'raw_copper', 'raw_gold', 'raw_iron', 'redstone',
  'scute', 'turtle_scute', 'shulker_shell', 'slime_ball', 'snowball',
  'spider_eye', 'stick', 'string', 'sugar', 'wheat',
  'breeze_rod', 'wind_charge',

  // Seeds & misc plantables (items, not blocks)
  'beetroot_seeds', 'melon_seeds', 'pumpkin_seeds', 'wheat_seeds',
  'torchflower_seeds', 'pitcher_pod',

  // Tools & equipment
  'bow', 'crossbow', 'fishing_rod', 'flint_and_steel', 'shears',
  'shield', 'trident', 'spyglass', 'brush', 'mace', 'elytra',
  'lead', 'saddle', 'name_tag', 'bundle', 'totem_of_undying',
  'fire_charge', 'firework_rocket', 'firework_star',

  // Maps, books, misc
  'map', 'filled_map', 'compass', 'recovery_compass', 'clock',
  'book', 'enchanted_book', 'writable_book', 'written_book',
  'knowledge_book', 'goat_horn',

  // Buckets
  'bucket', 'water_bucket', 'lava_bucket', 'milk_bucket',
  'powder_snow_bucket', 'axolotl_bucket', 'cod_bucket',
  'pufferfish_bucket', 'salmon_bucket', 'tadpole_bucket',
  'tropical_fish_bucket',

  // Entities / non-blocks
  'armor_stand', 'item_frame', 'glow_item_frame', 'painting',
  'end_crystal', 'minecart',

  // Arrows
  'arrow', 'spectral_arrow',

  // Smithing templates & patterns
  'bolt_armor_trim_smithing_template', 'netherite_upgrade_smithing_template',
  'flow_armor_trim_smithing_template',
  'creeper_banner_pattern', 'globe_banner_pattern', 'mojang_banner_pattern',
  'piglin_banner_pattern', 'skull_banner_pattern', 'flow_banner_pattern',

  // Trial keys
  'trial_key', 'ominous_trial_key',

  // Misc items
  'dragon_breath', 'wolf_armor', 'pumpkin_pie',
]);

function isBlock(value) {
  if (ITEM_EXACT.has(value)) return false;
  for (const suffix of ITEM_SUFFIXES) {
    if (value.endsWith(suffix)) return false;
  }
  for (const prefix of ITEM_PREFIXES) {
    if (value.startsWith(prefix)) return false;
  }
  return true;
}

const MINECRAFT_BLOCKS = [
  ...MINECRAFT_ITEMS.filter(item => isBlock(item.value)),
  // Blocks missing from the base items list
  { value: 'water', label: 'Water' },
  { value: 'lava', label: 'Lava' },
  { value: 'powder_snow', label: 'Powder Snow' },
  { value: 'copper_bars', label: 'Copper Bars' },
].sort((a, b) => a.label.localeCompare(b.label));

export default MINECRAFT_BLOCKS;
